import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import OnboardingFlow from './components/OnboardingFlow';
import AdminPanel from './components/AdminPanel';
import EmailMigration from './components/EmailMigration';
import BrowserEmailWrapper from './components/BrowserEmailWrapper';
import MigrationServices from './components/MigrationServices';
import NewsletterList from './components/NewsletterList';
import CompanyNewsletterManager from './components/CompanyNewsletterManager';
import CompanySelection from './components/CompanySelection';
import UserDashboard from './components/UserDashboard';
import UnifiedDashboard from './components/UnifiedDashboard';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Main Dashzap Routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/onboarding" element={<OnboardingFlow />} />
          <Route path="/company-selection" element={<CompanySelection />} />

          {/* Admin Dashboard - unified layout with sidebar */}
          <Route path="/admin-dashboard" element={<UnifiedDashboard />} />

          {/* Legacy routes - keeping for backwards compatibility */}
          <Route path="/admin-panel" element={<AdminPanel />} />
          <Route path="/admin/:company" element={<AdminPanel />} />
          <Route path="/user-dashboard" element={<UserDashboard />} />
          <Route path="/email-migration" element={<EmailMigration />} />
          <Route path="/browser-email" element={<BrowserEmailWrapper />} />
          <Route path="/migration-services" element={<MigrationServices />} />

          {/* Legacy Newsletter Routes */}
          <Route path="/newsletters" element={<NewsletterList />} />
          <Route path="/newsletter/:companyName" element={<CompanyNewsletterManager />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
